import { convertMathJax } from '~/lib/utils/mathjax';

const insertValue = (el, value, onRenderComplete) => {
  if (!value) {
    const text = el.innerHTML;

    if (/\$([^ ].*?[^ ])\$/.test(text) || /\$([^ ])\$/.test(text)) {
      convertMathJax(el, onRenderComplete);
    } else if (onRenderComplete) onRenderComplete();
  } else if (/\$([^ ].*?[^ ])\$/.test(value) || /\$([^ ])\$/.test(value)) {
    el.innerHTML = value;
    convertMathJax(el, onRenderComplete);
  } else {
    el.innerHTML = value;
    if (onRenderComplete) onRenderComplete();
  }
};
const getProps = (value) => {
  if (value === undefined) {
    return { content: null, onRenderComplete: null };
  }
  if (typeof value === 'string') {
    return { content: value, onRenderComplete: null };
  }
  return value;
};
const mathjax = {
  _content: '',
  created(el, binding, vnode, prevVnode) {
    const { content, onRenderComplete } = getProps(binding.value);
    el.___content = content ?? el.innerHTML;
    insertValue(el, content, onRenderComplete);
  },
  beforeUpdate(el, binding, vnode, prevVnode) {
    const { content, onRenderComplete } = getProps(binding.value);

    if (el.___content !== content) {
      insertValue(el, content, onRenderComplete);
      el.___content = content;
    }
  },
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('mathjax', mathjax);
});
